import React, { useState, useEffect } from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { Check as CheckIcon } from '@mui/icons-material';

const CHECKLIST = [
   'Exposure and lighting',
   'Color balance and warmth',
   'Contrast and dynamic range',
   'Sharpness and detail',
   'Shadow depth',
   'Saturation and vibrancy',
];

interface StepAnalyzeProps {
   isAnalyzing: boolean;
}

const StepAnalyze: React.FC<StepAnalyzeProps> = ({ isAnalyzing }) => {
   const [completedItems, setCompletedItems] = useState(0);

   useEffect(() => {
      if (!isAnalyzing) {
         setCompletedItems(CHECKLIST.length);
         return;
      }

      setCompletedItems(0);
      const interval = setInterval(() => {
         setCompletedItems((prev) => {
            if (prev >= CHECKLIST.length - 1) {
               clearInterval(interval);
               return prev;
            }
            return prev + 1;
         });
      }, 500);

      return () => clearInterval(interval);
   }, [isAnalyzing]);

   return (
      <Box sx={{ py: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3 }}>
         <CircularProgress sx={{ color: '#1D9E75' }} size={36} />
         <Typography variant="h6" sx={{ color: '#FFFFFF', fontWeight: 600, fontSize: '16px' }}>
            Analyzing your photo...
         </Typography>

         <Box sx={{ width: '100%', maxWidth: 320, mt: 1 }}>
            {CHECKLIST.map((item, i) => {
               const done = i < completedItems;
               return (
                  <Box key={item} sx={{
                     display: 'flex',
                     alignItems: 'center',
                     gap: 1.5,
                     py: 0.75,
                     transition: 'opacity 0.3s ease',
                     opacity: i <= completedItems ? 1 : 0.4,
                  }}>
                     {done ? (
                        <Box sx={{
                           width: 20, height: 20, borderRadius: '50%',
                           background: '#1D9E75',
                           display: 'flex', alignItems: 'center', justifyContent: 'center',
                        }}>
                           <CheckIcon sx={{ fontSize: 14, color: '#FFFFFF' }} />
                        </Box>
                     ) : i === completedItems ? (
                        <CircularProgress size={18} sx={{ color: '#1D9E75' }} thickness={5} />
                     ) : (
                        <Box sx={{
                           width: 20, height: 20, borderRadius: '50%',
                           border: '2px solid #253530',
                        }} />
                     )}
                     <Typography sx={{
                        fontSize: '13px',
                        color: done ? '#FFFFFF' : '#546E7A',
                        fontWeight: done ? 500 : 400,
                     }}>
                        {item}
                     </Typography>
                  </Box>
               );
            })}
         </Box>
      </Box>
   );
};

export default StepAnalyze;
